module.exports = __webpack_public_path__ + "img/logo.b50ac63a.png";